import {AddressTypeEnum} from '@c2b/muven-commons'

export class AddressModel {
    id?:string|number = undefined
    city:string = ''
    country:string = ''
    state:string = ''
    complement:string = ''
    reference:string = ''
    type:AddressTypeEnum = AddressTypeEnum.Delivery
    neighborhood:string = ''
    number:string = ''
    postalCode:string = ''
    receiverName:string = ''
    street:string = ''

    constructor(a?:Partial<AddressModel>) {
        Object.assign(this, a)
    }

    isDeliveryAddress():boolean {
        return this.type === AddressTypeEnum.Delivery ||
               this.type === AddressTypeEnum.Both
    }

    isBillingAddress():boolean {
        return this.type === AddressTypeEnum.Billing ||
               this.type === AddressTypeEnum.Both
    }
}
